// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"772":"e8e3774b","787":"67f654f7"}[chunkId] + ".chunk.js";
};